// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Vwp5","rootNoMargin":"styles_rootNoMargin__2pvHC"};